import { Typography } from '@sanlam-glacier/app-common/components';
import styles from './transaction-summary-row.module.scss';
import { TransactionSummaryRowProps } from 'modules/clients/types/transaction-summary';

const TransactionSummaryRow = ({ heading, amount, testid }: TransactionSummaryRowProps) => {
  return (
    <div className={styles.row}>
      <Typography data-testid={`${testid}RowDescription`} variant={Typography.VARIANT.B4}>
        {heading}
      </Typography>
      <Typography
        data-testid={`${testid}RowAmount`}
        variant={Typography.VARIANT.B4}
      >{`${amount}`}</Typography>
    </div>
  );
};

export default TransactionSummaryRow;
